import { render, staticRenderFns } from "./ListChassisEngine.vue?vue&type=template&id=5c4fbf64"
import script from "./ListChassisEngine.vue?vue&type=script&lang=js"
export * from "./ListChassisEngine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports